"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
exports.Validator = {
    name: "required_if_checkbox",
    isImplicit: true,
    errorMessage: "This field is required.",
    validate: function (value, requirement) {
        var _a = requirement.split(","), requiredField = _a[0], requiredValue = _a[1];
        var val = flatten(this.validator.input)[requiredField];
        if (typeof val === "string") {
            var values = val.split(":");
            if (!values.some(function (value) { return value === requiredValue; }))
                return true;
        }
        if (Array.isArray(value)) {
            return value.length !== 0;
        }
        return value !== "";
    },
};
// TODO: Remove
var dive = function (currentKey, into, target) {
    for (var i in into) {
        if (Object.prototype.hasOwnProperty.call(into, i)) {
            var newKey = i;
            var newVal = into[i];
            if (currentKey.length > 0) {
                newKey = currentKey + "." + i;
            }
            if (typeof newVal === "object") {
                dive(newKey, newVal, target);
            }
            else {
                target[newKey] = newVal;
            }
        }
    }
};
// TODO: Remove
var flatten = function (obj) {
    var newObj = {};
    dive("", obj, newObj);
    return newObj;
};
